// How an order counts a line's packs. A liquid is bought by the bottle it arrives in, whatever size
// is dispensed here, so a syrup reads "bottles of 60 ml" and never "packs of 3", which a supplier
// would take for a box of three (owner, 2026-10-19). `bottle` is the server's `supplierBottle`.

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

/** One of the line's packs: "bottle" or "pack". */
export const packWord = (bottle) => (bottle ? 'bottle' : 'pack');

/** What a line's packs are: "bottles of 60 ml", "packs of 10" or "single units". */
export const packKind = (bottle, upp) => {
  if (bottle) return `bottles of ${bottle}`;
  return upp > 1 ? `packs of ${upp}` : 'single units';
};

/**
 * The units in that many packs, in the bracket after a count: " (120)" for 2 packs of 60 (owner,
 * 2026-10-19). Nothing for a bottle, which already says its size, or for single units.
 */
export const unitsIn = (n, bottle, upp) =>
  !bottle && upp > 1 ? ` (${((Number(n) || 0) * upp).toLocaleString()})` : '';

/** A number of them: "3 bottles of 60 ml", "5 packs of 10 (50)", "2 packs". */
export const packCount = (n, bottle, upp) => {
  const count = plural(Number(n) || 0, packWord(bottle));
  if (bottle) return `${count} of ${bottle}`;
  return `${count}${upp > 1 ? ` of ${upp}` : ''}${unitsIn(n, bottle, upp)}`;
};

/** The order sheet's Pack column: "Bottle of 60 ml", "Pack of 10" or "Single". */
export const packLabel = (bottle, upp) => {
  if (bottle) return `Bottle of ${bottle}`;
  return upp > 1 ? `Pack of ${upp}` : 'Single';
};
